import { Route, Routes } from "react-router-dom";
import AccountMobileMenu from "../views/AccountMobileMenu";

function MobileRoutes() {
    let k = 0;
    return (
        [
            <Route key={k++} path="/mobile/account" element={<AccountMobileMenu />} />
        ]
    )
}

export default MobileRoutes;